<template>
  <component
    :is="'div'"
    :class="['ra-picker']"
  >

    <b-form
      class="navbar-search form-inline navbar-search-light"
      id="navbar-search-main"
    >
      <!-- <b-form-group class="mb-0"> -->



        <!-- <b-input-group class="input-group-alternative input-group-merge"> -->
          <!-- <div class="input-group-prepend">
            <span class="input-group-text"><i class="fas fa-search"></i></span>
          </div> -->
          <!-- <b-form-input v-model="searchLabel" v-on:keyup="doSearch" :placeholder="placeHolder" type="text"> </b-form-input> -->
            <el-input :clearable="true" v-model="searchLabel" @input="doSearch" :placeholder="placeHolder" :disabled="disabled" class="input-with-select">
            <el-select @change="setSearchParam" size="mini" slot="prepend" placeholder="Select" v-model="activeFilter" :disabled="disabled">
              <!-- <el-option label="Name" value="name"></el-option>
              <el-option label="Email" value="email"></el-option> -->
              <el-option
                v-for="item in searchParams.params"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <i slot="append" v-if="loading" class="fas fa-spinner fa-spin fa-fw"></i>
          </el-input>
            <!-- <div class="input-group-append">
                <span class="input-group-text"><i v-if="loading" class="fas fa-spinner fa-spin fa-fw"></i></span>
            </div> -->
        <!-- </b-input-group> -->
      <!-- </b-form-group> -->
    </b-form>

  </component>
</template>
<script>

import api from '@/api'
import { Select, Input,Option } from 'element-ui';

export default {
  name: 'auto-complete',
  props: {
    searchParams: {
      type: Object,
      default: {
        default: 'name',
        params: [
          {
            label: 'Name',
            value: 'name'
          }
        ]
      },
      description: ''
    },
    placeHolder: {
      type: String,
      default: '',
      description: ''
    },
    loading: {
      type: Boolean,
      default: false,
      description: ''
    },
    disabled: {
      type: Boolean,
      default: false,
      description: ''
    },
  },
  components: {
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
        searchLabel: '',
        searchTimer: null,
        activeFilter: this.searchParams.default
    };
  },
  methods: {
    setSearchParam: function(param) {
        this.$emit('onParamChanged', param);
    },
    triggerSearch: function() {
        this.$emit('onTyped', this.searchLabel);
    },
    doSearch: function(event) {
        this.$nextTick(() => {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(this.triggerSearch,500);
        });
    },
  }
}
</script>
